import { c as E } from "react/compiler-runtime";
import { useState as S, useEffect as b } from "react";
import { getSpeechRecognitionCtor as L } from "./speechRecognition.js";
const m = L();
class l {
  recognition;
  listening = !1;
  static isSupported() {
    return !!m;
  }
  constructor(n = "en-US") {
    if (!m)
      throw new Error("Speech recognition is not supported in this browser");
    this.recognition = new m(), this.recognition.lang = n;
  }
  start() {
    if (!l.isSupported()) {
      console.error("Speech recognition is not supported in this browser");
      return;
    }
    this.listening = !0, this.recognition.start();
  }
  onStart(n) {
    this.listening = !0, this.recognition.onaudiostart = n;
  }
  onEnd(n) {
    this.listening = !1, this.recognition.onaudioend = n;
  }
  onError(n) {
    this.recognition.onerror = (e) => {
      n(e.error);
    };
  }
  stop() {
    this.recognition.stop(), this.listening = !1;
  }
  onResult(n) {
    this.recognition.onresult = (e) => {
      console.log(e.results);
      const i = e.results[e.results.length - 1][0].transcript;
      this.listening = !1, n(i);
    };
  }
}
const o = l.isSupported() ? new l() : null, x = () => {
  const t = E(8), [n, e] = S(null), [i, h] = S(o?.listening), [f, s] = S(null);
  let c, u;
  t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = () => {
    if (!l.isSupported()) {
      s("Speech recognition is not supported in this browser");
      return;
    }
    o?.onStart(() => {
      s(null), e(null), h(!0);
    }), o?.onResult((r) => {
      e(r), s(null);
    }), o?.onError((r) => {
      s(r), e(null), h(!1);
    }), o?.onEnd(() => {
      s(null), e(null), h(!1);
    });
  }, u = [], t[0] = c, t[1] = u) : (c = t[0], u = t[1]), b(c, u);
  let g;
  t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = function() {
    o?.start();
  }, t[2] = g) : g = t[2];
  const d = g;
  let p;
  t[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = function() {
    o?.stop();
  }, t[3] = p) : p = t[3];
  const w = p;
  let a;
  return t[4] !== f || t[5] !== i || t[6] !== n ? (a = {
    transcript: n,
    error: f,
    startListening: d,
    stopListening: w,
    isListening: i
  }, t[4] = f, t[5] = i, t[6] = n, t[7] = a) : a = t[7], a;
};
export {
  x as useSpeechToText
};
